// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4480":"44d8cc3e","8240":"44d8cc3e"}[chunkId] + ".chunk.css";
};